<template>
  <div>
    <Head title="Busy Stations" />
    <h1 class="mb-8 text-3xl font-bold">Ombrelloni occupati</h1>

    <section id="day-pass">
      <div class="flex items-center justify-center min-h-fit">
        <div :class="{'w-full': !isFullScreen, 'w-full h-screen': isFullScreen}" class="rounded-lg p-6 bg-white">
          <div class="flex flex-col lg:flex-row">
            <div class="w-full lg:w-5/12 xl:w-3/12">
              <div class="rounded-lg">
                <DatePicker
                  v-model="selectedDate" borderless class="rounded-lg border w-full" expanded
                  locale="it"
                  mode="date"
                />
              </div>
            </div>
            <div class="w-full mt-2 lg:mt-0 lg:ml-2 lg:w-7/12 xl:w-9/12">
              <div class="rounded-lg border h-full bg-green-100 relative">
                <pool-map
                    ref="poolMap"
                    :busy="busy"
                    :allow-untoggle="true"
                    :ask-confirm="false"
                    :is-map-in-dashboard="true"
                    :show-numbers="!isSafari()"
                    @update-stations="confirmUpdateStations"
                />
                  <button
                      class="absolute top-2 right-2 bg-gray-700 hover:bg-gray-900 text-white font-bold py-2 px-4 rounded"
                      type="button"
                      @click="$refs.poolMap.toggleFullScreen"
                  >
                      {{ isFullScreen ? 'Esci Full-Screen' : 'Full-Screen' }}
                  </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import Modal from "@/Pages/Bookings/BookingScanner.vue";
import DashboardLayout from "@/Pages/Dashboard/Shared/DashboardLayout";
import Icon from "@/Pages/Dashboard/Shared/Icon";
import Pagination from "@/Pages/Dashboard/Shared/Pagination";
import SearchFilter from "@/Pages/Dashboard/Shared/SearchFilter";
import PoolMap from "@/Pages/Home/Checkout/PoolMap.vue";
import NumberInput from "@/Pages/Home/Checkout/partials/NumberInput.vue";
import { isSafari } from "@/Shared/helper";
import { Head, Link } from "@inertiajs/inertia-vue3";
import axios from "axios";
import moment from "moment";
import { DatePicker } from "v-calendar";

export default {
  components: {
    NumberInput,
    PoolMap,
    DatePicker,
    Head,
    Icon,
    Link,
    Pagination,
    SearchFilter,
    Modal,
  },
  layout: DashboardLayout,
  props: {
    filters: Object,
    bookings: Object,
  },
  emits: ["updateStations"],
  data() {
    return {
      selectedDate: new Date(),
      busy: [],
      isFullScreen: false, // New data property for full-screen state
    };
  },
  watch: {
    selectedDate(newDate) {
      const selectedDate = newDate || new Date();
      this.fetchBusyStations(selectedDate);
    },
  },
  mounted() {
    this.fetchBusyStations(this.selectedDate);

    setInterval(() => {
      this.fetchBusyStations(this.selectedDate);
    }, 30000); // 30 seconds interval
  },
  methods: {
    isSafari,
    async fetchBusyStations(date) {
      try {
        const formattedDate = moment(date).format("YYYY-MM-DD");
        const response = await axios.get(`/busy?date=${formattedDate}`);
        this.busy = response.data.data.busy;
      } catch (error) {
        console.error("Error fetching busy stations:", error);
      }
    },
    async updateStations(stations) {
      try {
        await axios.post("/bookings/busy", {
          date: this.selectedDate,
          stations: stations,
        });
        await this.fetchBusyStations(this.selectedDate);
        this.$refs.poolMap.clearSelectedStations();
      } catch (error) {
        console.error("Error fetching busy stations:", error);
      }
    },
    confirmUpdateStations(stations) {
      this.updateStations(stations);
    },
  },
};
</script>

<style scoped>
/* Additional styles for full-screen mode */
.w-full.h-screen {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9999;
  overflow: auto;
}
</style>
